import React, { useCallback, useContext, useEffect, useState } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, TextField, Tooltip, Typography } from "@mui/material";
import CommonGrid from "../Repository/CommonGrid";
import { useTranslation } from "react-i18next";
import { treeActions } from "../../redux/slices/treeSlice";
import TestData from "../ItemProperties/Forms/Advanced Properties/TestData";
import { api } from "../../redux/api";
import { debounce } from "lodash";
import LightTooltip from "../../commonComponents/LightTooltip";
import { customDecoding, customEncoding } from "../../utils/utilFunctions";

const newSubstitutions = {
	valueToReplace: "",
	replaceValue: "",
	isRegularExpression: false,
};

const GlobalSubstitutions = () => {
	const parentScreen = useContext(ParentScreenCtx);
	const { leftTree, rightTree } = useSelector(
		(state) => state.treeData[parentScreen]
	);
	const templateHeader = rightTree.tree.templateHeader;
    const { account } = useSelector((state) => state.queryParams);
	const leftSelectedNode = leftTree.tree.body.selectedNode;
	const [rowData, setRowData] = useState([]);
    const [valueToReplace, setValueToReplace] = useState('');
    const [replacemenetValue, setReplacementValue] = useState('');
    const [replaceType, setReplaceType] = useState(false);
    const [testData, setTestData] = useState('');
    const [testResult, setTestResult] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
	const [selectedSubstitution, setSelectedSubstitution] = useState();
	const [gridAPI, setGridAPI] = useState();
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const customClickHandlerOnAdd = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, {
			...newSubstitutions,
		});
		substitutionHandler(
			[...data],
			data.length && selectedRows?.length ? +selectedRows?.[0]?.id + 1 : 0,
			e.api
		);
		submitChange(data);
	};

	const deleteActionHandler = (e) => {
		const data = [];
		e.api.forEachNode((node) => {
			if (e.data.id !== node.data.id) data.push(node.data);
		});
		substitutionHandler([...data], 0, e.api);
		submitChange(data);
	};

	const copyActionHandler = (e) => {
		const data = [];
		const selectedRows = e.api.getSelectedRows();
		e.api.forEachNode((node) => {
			data.push(node.data);
		});
		data.splice(+(selectedRows?.[0]?.id || 0) + 1, 0, selectedRows?.[0]);
		substitutionHandler([...data], +selectedRows?.[0]?.id + 1, e.api);
		submitChange(data);
	};

	const substitutionHandler = (data = [], selectionIndex, gridAPI) => {
		if (!gridAPI) {
			setRowData([]);
			return;
		}
        
		const rowData = data?.map((e, i) => {
			let title = `${t("FRG_REPLACE_")}${customDecoding(e?.valueToReplace || "")} ${t("FRG_WITH_")}${customDecoding(e?.replaceValue || "")} (${e?.isRegularExpression ? t("FRG_REG_EX") : t("FRG_VERBATIM")})`
			return {
				...e,
				key: title,
				id: i,
			};
		});
		gridAPI.setGridOption('rowData', rowData)
        
		setTimeout(() => {
			gridAPI.forEachNode((node) => {
				if (node?.data?.id === selectionIndex) {
					node.setSelected(true);
					setSelectedSubstitution(node.data);
					// gridAPI.ensureNodeVisible(node);
				}
			});
			if (!rowData?.length) setSelectedSubstitution({});
		}, 100);
	};

	const CustomCellRenderer = (info) => {
		const { value, data } = info;
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					height: "2rem",
				}}
			>
				<div className='truncated-text' title={value}>
					{value}
				</div>
				<div className='flex align-center'>
					<LightTooltip onClick={() => deleteActionHandler(info)}>
						<span
							style={{ cursor: "pointer" }}
							className='DELETE_MUI'
							// onClick={() => handleDelete(value, data?.data)}
						></span>
					</LightTooltip>
					<LightTooltip onClick={() => copyActionHandler(info)}>
						<span
							style={{ cursor: "pointer" }}
							className='FILE_COPY'
							// onClick={() => handleCopy(value, data?.data)}
						></span>
					</LightTooltip>
				</div>
			</div>
		);
	};

	let gridOptions = {
		columnDefs: [
			{
				addNewControl: true,
				addControlLabel: t("HOVER_MSSG_ADD_GLOBAL_SUBSTITUTION"),
				customClickHandlerOnAdd: customClickHandlerOnAdd,
				headerName: t("LBL_GLOBAL_SUBSTITUTIONS"),
				field: "key",
				editable: false,
				resizable: false,
				cellRenderer: (info) => CustomCellRenderer(info),
				rowDrag: true,
			},
		],
		onRowDragEnd: function (event) {
			// Handle row drag end event here
			const newRowData = [];
			const selectedNodes = event.api.getSelectedRows();
			let newSelectedId = null;
			event.api.forEachNodeAfterFilterAndSort(function (node, i) {
				newRowData.push({ ...node.data, id: i });
				if (selectedNodes[0]?.id === node.data.id) newSelectedId = i;
			});
			submitChange(newRowData);
			event.api.setGridOption('rowData', newRowData)
			if (newSelectedId !== null)
				substitutionHandler(newRowData, newSelectedId, event.api);
		},
		rowDragManaged: true,
	};

	const handleGlobalSubstitutions = (globalSubstitutions) => {
		const substitutionsArray =
			globalSubstitutions?.split("%1E")?.filter((e) => e) || [];
		const finalArray = substitutionsArray.map((e) => {
			const values = e?.split("%1F");
			const isRegularExpression = values?.[0]?.startsWith("%1D");
			const valueToReplace = decodeURIComponent(values[0]?.replace("%1D", ""));
			const replaceValue = decodeURIComponent(values[1]);
			return {
				valueToReplace,
				replaceValue,
				isRegularExpression,
			};
		});
		substitutionHandler(finalArray, 0, gridAPI);
	};

    const recieveTestReqeust = (val) => {
        if (val) {
          // Clear previous test result and error before making new request
          setTestResult('');
          setErrorMessage('');
          
          if (!testData || testData.trim() === '') {
            setErrorMessage('Please enter test data');
            return;
          }

          // Check if there are any substitutions to test
          const testingReplacements = createTestingRequest();
          if (!testingReplacements || testingReplacements.length === 0) {
            setErrorMessage('Please add at least one global substitution to test');
            return;
          }
          
          const payload = { testData: testData === '\\n' ? '\\n' : testData, replacements: testingReplacements };
          testDataFromServer(payload);
        }
    }

    const testDataFromServer = (data) => {
        setLoading(true);
        const payload = { ...data, testData: (data?.testData || '').replace(/CRLF/g, "\\n") };
        dispatch(api.endpoints.testGlobalSubstitutionJson.initiate({
          account,
          data: payload,
        })).then((response) => {
          if (response && response.data.current_state === 'SUCCESS') {
            setTestResult(response.data.data);
            setLoading(false);
            setErrorMessage('');
          } else {
            setTestResult(''); // Clear test result on error
            setErrorMessage(response.data.message || 'Something Went Wrong');
            setLoading(false);
          }
        })
        .catch(e => {
            setTestResult(''); // Clear test result on error
            setErrorMessage(e.message || 'An unexpected error occurred');
            setLoading(false);
        })
    }

    const createTestingRequest = () => {
        // Always send all substitutions for testing (structured)
        const values = [];
        gridAPI.forEachNode(node => {
          values.push(node.data);
        });
        return values
          .filter(Boolean)
          .map(sub => ({
            type: sub?.isRegularExpression ? 'REG_EX' : 'VERBATIM',
            replace: customDecoding(sub?.valueToReplace || ''),
            with: customDecoding(sub?.replaceValue || ''),
          }));
    }

    const getTestData = (val) => {
    setTestData(val);
    }

    const onSelectHandler = (gridOptions) => {
		const selectedRows = gridOptions.api.getSelectedRows();
		setSelectedSubstitution(selectedRows[0]);
	};

    const substitutionChangeHandler = (key, value) => {
        if (!gridAPI) return;
        const data = []
		const selectedSubstitution = gridAPI.getSelectedRows()?.[0] || {};
        gridAPI.forEachNode((node) => {
            if (node?.data?.id === selectedSubstitution?.id) {
                const updatedData = {
                    ...node?.data,
                    [key]: value
                };
                // Update the key for display purposes
                let title = `${t("FRG_REPLACE_")}${customDecoding(updatedData?.valueToReplace || "")} ${t("FRG_WITH_")}${customDecoding(updatedData?.replaceValue || "")} (${updatedData?.isRegularExpression ? t("FRG_REG_EX") : t("FRG_VERBATIM")})`
                updatedData.key = title;
                data.push(updatedData);
                // Update the node data directly without refreshing the entire grid
                node.setSelected(true);
                node.setData(updatedData);
            } else {
                data.push(node?.data);
            }
        });
        submitChange(data);
    }

	useEffect(() => {
        if (gridAPI) {
            handleGlobalSubstitutions(templateHeader?.GLOBAL_REPLACE || "");
        }
	}, [rightTree.loading,  gridAPI]);

    const getGlobalSubstitutionString = (values = []) => {
        let globalString = "";
        values?.forEach(e => {
            const subString = `${e?.isRegularExpression ? "%1D" : ""}${customEncoding(e?.valueToReplace)}%1F${customEncoding(e?.replaceValue)}%1E`
            globalString += subString;
        })
        return globalString;
    }

    const submitChange = (value)=>{
        dispatch(
            treeActions.setRightTreeTemplateHeaders(
                {
                    screen: parentScreen, 
                    key: "GLOBAL_REPLACE", 
                    value: getGlobalSubstitutionString(value)
                }
        ));
    }


    useEffect(() => {
        setValueToReplace(customDecoding(selectedSubstitution?.valueToReplace || ''));
        setReplacementValue(customDecoding(selectedSubstitution?.replaceValue || ''));
        setReplaceType(selectedSubstitution?.isRegularExpression || false);
    },[selectedSubstitution?.id, selectedSubstitution])


    const debounceChangeHandler = useCallback(debounce(substitutionChangeHandler, 200), [
		leftSelectedNode?.key
	]);

	return (
		<Box padding={"10px"}>
			<Box className='div-textBox-action' sx={{border: "2px"}}>
				<CommonGrid
					rowData={rowData}
					gridOptions={gridOptions}
					containerStyle={{ height: "100% !important" }}
					gridResizable={true}
					getGridAPI={(e, gridRef) => {
						setGridAPI(gridRef.api);
					}}
					gridProps={{
						overlayNoRowsTemplate: "No Data",
						rowSelection: "single",
						onSelectionChanged: onSelectHandler,
					}}
				/>
			</Box>
            <Stack spacing={"15px"} paddingTop={"15px"}>
                <FormControl variant='outlined' className='width-100' size='small'>
                        <TextField
                            disabled={!selectedSubstitution?.hasOwnProperty("id")}
                            autoComplete={"off"}
                            size='small'
                            value={valueToReplace}
                            label={t("LBL_VAL_TO_REPLACE")}
                            onChange={(e) => {
                                const { value } = e.target;
                                setValueToReplace(value);
                                debounceChangeHandler("valueToReplace", value);
                            }}
                        />
                </FormControl>
                <FormControl variant='outlined' className='width-100' size='small'>
                        <TextField
                            disabled={!selectedSubstitution?.hasOwnProperty("id")}
                            autoComplete={"off"}
                            size='small'
                            value={replacemenetValue}
                            label={t("LBL_REPLACEMENT_VAL")}
                            onChange={(e) => {
                                const { value } = e.target;
                                setReplacementValue(value);
                                debounceChangeHandler("replaceValue", value);
                            }}
                        />
                </FormControl>
                <FormControl>
                    <RadioGroup
                        disabled={!selectedSubstitution?.hasOwnProperty("id")}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={false}
                        name="radio-buttons-group"
                        value={replaceType}
                        onChange={(e) => {
                            const value = e.target.value === "true"
                            setReplaceType(value);
                            debounceChangeHandler("isRegularExpression", value);
                        }}
                    >
                        <FormControlLabel  disabled={!selectedSubstitution?.hasOwnProperty("id")} value={false} control={<Radio />} label={t('BTN_USE_VAL_TO_REPLACE_VERBATIM')} />
                        <FormControlLabel  disabled={!selectedSubstitution?.hasOwnProperty("id")} value={true} control={<Radio />} label={t('BTN_USE_VAL_TO_REPLACE_EXPR')} />
                    </RadioGroup>
                </FormControl>
                <Button 
										size='small'
                    disabled={!selectedSubstitution?.hasOwnProperty("id")}
                    variant="outlined" 
                    onClick={() => {
                        dispatch(treeActions.setShowHelpPanel({
                            docType: "REGULAR_EXPRESSION",
                            isOpen: true
                        }));
                    }}
                >
                    {t("BTN_REG_EXPR_HELP")}
                </Button>
				
                <TestData 
					errorMessage={errorMessage}
                    testResult={testResult} 
                    getTestData={getTestData} 
                    type={'LBL_TEST_REPL_HERE'} 
                    sendTestRequest={recieveTestReqeust} 
                    isLoading={loading}
                    disabled={!selectedSubstitution?.hasOwnProperty("id")}
                />
                
            </Stack>
		</Box>
	);
};

export default GlobalSubstitutions;
